<template>
    <vue-typeahead-bootstrap v-model="searchedCustomer" :required="required" :data="customers" :serializer="s =>
        `${s.name} ${s.email ? ' --Email:' + s.email : ''}  ${s.phone ? ' --Phone:' + s.phone : ''
        }`
        " @hit="getCustomer" @input="lookupCustomers" @queryOptionsValue="queryOptionsValue"
        :placeholder="$translate('search_with_customer_name')" :disabled="disabled"
        backgroundVariant="list-group-item list-group-item-light" />
</template>
<script>
import VueTypeaheadBootstrap from '@/components/VueTypeAhead/VueTypeaheadBootstrap'

import { debounce } from 'lodash'
export default {
    components: { VueTypeaheadBootstrap },
    props: ['value', 'disabled','required'],
    data: () => ({
        filters: { queryOptionsValue: 'starts_with' },
        searchedCustomer: '',
    }),
    computed: {
        customers() {
            const customers = this.$store.getters['customers/customers']
            console.log('customers;--', customers)
            return customers
        },
        customer() {
            return this.$store.getters['customers/customer']
        },
        customerId() {
            return this.$store.state.customers.customerId
        },
    },
    watch: {
        searchedCustomer: function (to, from) {
            if (from && to === '') {
                this.$emit('input', null)
                this.$emit('set-customer', null)
            }
        },
        value: async function (id) {
            await this.setValue(id)
        },
        customerId: async function () {
            await this.setValue(this.customerId)
            this.getCustomer(this.customer)
        },

    },
    async mounted() {
        console.log('this.value', this.value)
        await this.setValue(this.value)
    },
    methods: {
        async setValue(id) {
            const coinedError = 'invalid customer id'
            try {
                id = parseInt(id)
                if (!id) throw new Error(coinedError)
                if (id > 0) {
                    await this.$store.dispatch('customers/fetchById', id)
                    await this.$nextTick()
                    this.searchedCustomer = this.customer.name
                }
            } catch (err) {
                if (err.message != coinedError) {
                    console.log('customer id', id)
                    console.log('err', err)
                }
                this.searchedCustomer = ''
            }
        },
        getCustomer(customer) {
            console.log('customer---', customer)
            this.$emit('input', customer.id)
            this.$emit('set-customer', customer)
        },
        queryOptionsValue(val) {
            this.filters.queryOptionsValue = val
            this.lookupCustomers()
        },

        lookupCustomers: debounce(function () {
            // in practice this action should be debounced
            const { searchedCustomer: query, filters } = this
            if (query.length >= 3) {
                const page = 1
                this.$store.dispatch('customers/fetch', { page, query, filters, })
            }
        }, 500),
    },
}
</script>